<template>
  <div class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- First Name -->
      <div class="space-y-2">
        <label class="text-sm font-semibold text-foreground px-1">First Name</label>
        <input
          :value="firstName"
          @input="$emit('update:firstName', $event.target.value)"
          type="text"
          placeholder="First name"
          class="block w-full px-4 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 focus:border-primary/30 transition-all"
        />
      </div>

      <!-- Last Name -->
      <div class="space-y-2">
        <label class="text-sm font-semibold text-foreground px-1">Last Name</label>
        <input
          :value="lastName"
          @input="$emit('update:lastName', $event.target.value)"
          type="text"
          placeholder="Last name"
          class="block w-full px-4 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 focus:border-primary/30 transition-all"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicInfoForm",
  props: {
    firstName: {
      type: String,
      default: "",
    },
    lastName: {
      type: String,
      default: "",
    },
  },
  emits: ["update:firstName", "update:lastName"],
};
</script>
